import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const AllotmentValidation = z.object({
  value: z.number({ message: '[Allotment] value is required' }),
})

export class Allotment extends Model {
  static create({ value }: z.infer<typeof AllotmentValidation>) {
    AllotmentValidation.parse({ value })
    return new Allotment(value)
  }

  public readonly value: number

  constructor(value: number) {
    super()
    this.value = value
  }

  toJSON() {
    return { value: this.value }
  }

  isTheLastOne() {
    return this.value === 1
  }
}
